import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "../features/auth/AuthSlice";
import CategorySlice from "../features/category/CategorySlice";
import ItemSlice from "../features/item/ItemSlice";
import TableSlice from "../features/table/TableSlice";
import ToppingSlice from "../features/topping/ToppingSlice";
import CheeseSlice from "../features/cheese/CheeseSlice";
import OrderSlice from "../features/order/OrderSlice";
import FilterSlice from "../features/filter/FilterSlice";
import IngredientSlice from "../features/ingredient/IngredientSlice";
import DayStartSlice from "../features/dayStart/DayStartSlice";
import ReportSlice from "../features/report/ReportSlice";
import CashInOutSlice from "../features/cashInOut/CashInOutSlice";
import WaiterSlice from "../features/waiter/WaiterSlice";
import PurchaseSlice from "../features/Purchase/PurchaseSlice";
import NotificationSlice from "../features/notification/NotificationSlice";
import InventoryAdjustSlice from "../features/inventoryAdjust/InventoryAdjustSlice";
import UnitOfMeasureSlice from "../features/unitOfMeasure/UnitOfMeasureSlice";
import { apiSlice } from "../features/apiSlice/apiSlice";

export const store = configureStore({
  reducer: {
    auth: AuthSlice,
    category: CategorySlice,
    item: ItemSlice,
    ingredient: IngredientSlice,
    table: TableSlice,
    topping: ToppingSlice,
    cheese: CheeseSlice,
    order: OrderSlice,
    filter: FilterSlice,
    dayStart: DayStartSlice,
    report: ReportSlice,
    cashInOut: CashInOutSlice,
    waiter: WaiterSlice,
    purchase: PurchaseSlice,
    notification: NotificationSlice,
    inventoryAdjust: InventoryAdjustSlice,
    unitOfMeasure: UnitOfMeasureSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
